const CHATGPT_REDIRECT_ORIGIN = 'https://chatgpt.com';
const CHATGPT_REDIRECT_PATH = '/connector_platform_oauth_redirect';
const VALID_REQUEST_ID = /^[A-Za-z0-9_-]{43}$/;
const ALLOWED_REDIRECT_QUERY_PARAMETERS = new Set(['state', 'code', 'error', 'iss']);

export function isValidChatGPTRequestId(requestId: string | null): requestId is string {
  return Boolean(requestId && VALID_REQUEST_ID.test(requestId));
}

export function getChatGPTConsentReturnTo(returnTo: string | null): string {
  if (!returnTo) return '/dashboard';

  try {
    const url = new URL(returnTo, window.location.origin);
    if (
      url.origin === window.location.origin &&
      url.pathname === '/chatgpt/consent' &&
      isValidChatGPTRequestId(url.searchParams.get('request'))
    ) {
      return `${url.pathname}${url.search}`;
    }
  } catch {
    // A malformed continuation should fall back to the existing dashboard flow.
  }

  return '/dashboard';
}

export function isAllowedChatGPTRedirect(redirectUrl: string): boolean {
  try {
    const url = new URL(redirectUrl);
    if (
      url.protocol !== 'https:' ||
      url.origin !== CHATGPT_REDIRECT_ORIGIN ||
      url.pathname !== CHATGPT_REDIRECT_PATH ||
      url.username ||
      url.password ||
      url.hash
    ) {
      return false;
    }

    return Array.from(url.searchParams.keys()).every((key) => ALLOWED_REDIRECT_QUERY_PARAMETERS.has(key));
  } catch {
    return false;
  }
}
